import { render, staticRenderFns } from "./DevTest.vue?vue&type=template&id=0f115a43&scoped=true&"
import script from "./DevTest.vue?vue&type=script&lang=js&"
export * from "./DevTest.vue?vue&type=script&lang=js&"
import style0 from "./DevTest.vue?vue&type=style&index=0&id=0f115a43&scoped=true&lang=css&"
import style1 from "./DevTest.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f115a43",
  null
  
)

export default component.exports